import styled, { CSSObject } from 'styled-components';
import Icon from '../Icon';

export const CloseIcon = styled(Icon)(({ theme, active }) => ({
  color: active ? theme.color.wfWhite : theme.color.wfBlack,
}));

interface TabStyledProps {
  active?: boolean;
}

export const FloatingTabStyled = styled.div<TabStyledProps>(
  ({ theme, active }) => {
    let styleSheet: CSSObject = {
      marginRight: theme.space[4],
      cursor: 'pointer',
      display: 'inline-flex',
      flexShrink: 0,
      alignItems: 'center',
      borderRadius: theme.space[6],
      padding: `${theme.space[1]} ${theme.space[5]}`,
      fontSize: theme.font.size.small,
      background: theme.color.wfGrey100,
      border: `1px solid ${theme.color.wfGrey200}`,
      color: theme.color.wfBlack,
      boxSizing: 'border-box',
      ':first-child': {
        marginLeft: theme.space[4],
      },
      '&:hover': {
        borderColor: theme.color.wfBlack,
      },

      '-webkit-user-select': 'none' /* Safari */,
      '-moz-user-select': 'none' /* Firefox */,
      '-ms-user-select': 'none' /* IE10+/Edge */,
      'user-select': 'none' /* Standard */,
    };

    if (active) {
      styleSheet = {
        ...styleSheet,
        color: theme.color.wfWhite,
        background: theme.color.primary,
        borderColor: theme.color.primary,
        '&:hover': {
          borderColor: theme.color.primary,
        },
      };
    }

    return styleSheet;
  },
);
